<section id="footer" [ngClass]="{'arabic-css': isArabic()}">
	<footer>
		<div class="main-footer row">
			<div class="container clear-padding">
				<div class="col-md-2 col-sm-0"></div>
				<div *ngIf="baseService.currentPlatform.profiles" class="col-md-4 col-sm-6 about-box">
					<h3>{{clientName}}</h3>
					<p *ngIf="baseService.getLanguage() == 'fr'">
						{{ baseService.currentPlatform.profiles["DESCRIPTION_FR"] }}
					</p>
					<p *ngIf="baseService.getLanguage() == 'ar'">
						{{ baseService.currentPlatform.profiles["DESCRIPTION_AR"] }}
					</p>
					<p *ngIf="baseService.getLanguage() == 'en'">
						{{ baseService.currentPlatform.profiles["DESCRIPTION_EN"] }}
					</p>
					<p *ngIf="baseService.currentPlatform.profiles['HELPDESK']">
						{{ "HELPDESK" | translate }} :
						<a [href]="baseService.currentPlatform.profiles['HELPDESK']">
							{{ baseService.currentPlatform.profiles["HELPDESK"] }}
						</a>
					</p>
				</div>

				<div class="col-md-1 col-sm-1 contact-box"></div>
				<div class="col-md-4 col-sm-6 contact-box">
					<h4>{{"CONTACT_US"|translate}}</h4>
					<div class="flex-info">
						<p>
							<i class="fa fa-home"></i>
							Alger, Algérie
						</p>
						<p><i class="fa fa-phone"></i> +213 7 83 26 73 82</p>
						<p><i class="fa fa-envelope-o"></i>contact@123fly.co</p>
					</div>
				</div>
				<div class="clearfix"></div>
				<div class="col-md-12 text-center we-accept">
					<h4>{{"SOCIAL_MEDIA"|translate}}</h4>
					<div class="social-media">
						<ul class="social-media-footer">
							<li>
								<a href="https://m.facebook.com/people/123flyco/100094628710940/"
									>
									<svg
										width="20px"
										height="20px"
										viewBox="0 0 20 20"
										version="1.1"
										xmlns="http://www.w3.org/2000/svg"
										xmlns:xlink="http://www.w3.org/1999/xlink">
										<g
											id="Symbols"
											stroke="none"
											stroke-width="1"
											fill="none"
											fill-rule="evenodd">
											<g
												id="footer/idle"
												transform="translate(-120.000000, -130.000000)">
												<rect
													fill="#F5F6F6"
													x="0"
													y="0"
													width="1440"
													height="522" />
												<g
													id="Icon/facebook"
													transform="translate(120.000000, 130.000000)"
													fill="#3A3A3A">
													<g id="footer-facebook-(1)">
														<path
															d="M20,10.0611134 C20,4.50450981 15.5228516,0 10,0 C4.47714844,0 0,4.50450981 0,10.0611134 C0,15.0829059 3.65685547,19.24522 8.4375,20 L8.4375,12.969404 L5.89843749,12.969404 L5.89843749,10.0611134 L8.4375,10.0611134 L8.4375,7.84452436 C8.4375,5.32295781 9.93042968,3.93012242 12.2146484,3.93012242 C13.3087304,3.93012242 14.4531251,4.12662855 14.4531251,4.12662855 L14.4531251,6.60260567 L13.1921484,6.60260567 C11.9499023,6.60260567 11.5625,7.37815638 11.5625,8.17380966 L11.5625,10.0611134 L14.3359375,10.0611134 L13.8925781,12.969404 L11.5625,12.969404 L11.5625,20 C16.3431445,19.24522 20,15.0829059 20,10.0611134"
															id="Facebook"
															fill-rule="nonzero" />
													</g>
												</g>
											</g>
										</g></svg
								></a>
							</li>
							<li>
								<a href="https://www.instagram.com/123fly.co/"
									><svg
										width="20px"
										height="20px"
										viewBox="0 0 20 20"
										version="1.1"
										xmlns="http://www.w3.org/2000/svg"
										xmlns:xlink="http://www.w3.org/1999/xlink">
										<g
											id="Symbols"
											stroke="none"
											stroke-width="1"
											fill="none"
											fill-rule="evenodd">
											<g
												id="footer/idle"
												transform="translate(-165.000000, -130.000000)">
												<rect
													fill="#F5F6F6"
													x="0"
													y="0"
													width="1440"
													height="522" />
												<g
													id="Icon/Instagram_black"
													transform="translate(165.000000, 130.000000)"
													fill="#3A3A3A">
													<path
														d="M0,10 C0,4.47715223 4.47715223,0 10,0 C15.5228478,0 20,4.47715223 20,10 C20,15.5228478 15.5228478,20 10,20 C4.47715223,20 0,15.5228478 0,10 Z M10.0005,4.66666667 C8.55204047,4.66666667 8.3702608,4.67300007 7.801366,4.69888923 C7.2335823,4.7248895 6.8460227,4.81477933 6.50690807,4.9466696 C6.15612663,5.08289323 5.85856797,5.26511733 5.56212043,5.561676 C5.26545067,5.85812353 5.08322657,6.15568217 4.94655847,6.5063525 C4.81433487,6.84557827 4.72433393,7.23324897 4.6987781,7.80081043 C4.6733334,8.36970523 4.66666667,8.55159603 4.66666667,10.0000556 C4.66666667,11.4485151 4.67311117,11.6297392 4.69888923,12.198634 C4.7250006,12.7664177 4.81489043,13.1539773 4.9466696,13.4930919 C5.08300433,13.8438734 5.26522847,14.141432 5.5617871,14.4378796 C5.85812353,14.7345493 6.15568217,14.9172179 6.5062414,15.0534415 C6.84557827,15.1853318 7.23324897,15.2752216 7.80092153,15.3012219 C8.36981637,15.327111 8.5514849,15.3334444 9.99983333,15.3334444 C11.448404,15.3334444 11.6296281,15.327111 12.1985229,15.3012219 C12.7663066,15.2752216 13.1543106,15.1853318 13.4936475,15.0534415 C13.8443178,14.9172179 14.141432,14.7345493 14.4377684,14.4378796 C14.7344382,14.141432 14.9166623,13.8438734 15.0533304,13.4932031 C15.1844429,13.1539773 15.2744438,12.7663066 15.3011108,12.1987451 C15.3266666,11.6298503 15.3333333,11.4485151 15.3333333,10.0000556 C15.3333333,8.55159603 15.3266666,8.36981637 15.3011108,7.80092153 C15.2744438,7.23313783 15.1844429,6.84557827 15.0533304,6.5064636 C14.9166623,6.15568217 14.7344382,5.85812353 14.4377684,5.561676 C14.1410987,5.26500623 13.8444289,5.0827821 13.4933142,4.9466696 C13.1533106,4.81477933 12.7655288,4.7248895 12.1977451,4.69888923 C11.6288503,4.67300007 11.4477373,4.66666667 9.99883333,4.66666667 L10.0005,4.66666667 Z"
														id="Combined-Shape" />
													<path
														d="M9.52205057,5.6277878 C9.66405207,5.62756557 9.82249817,5.6277878 10.0005,5.6277878 C11.4245148,5.6277878 11.5932944,5.63289897 12.1556336,5.65845477 C12.675639,5.6822328 12.9578641,5.7691226 13.1458661,5.84212337 C13.3947576,5.93879103 13.5722039,6.0543478 13.7587614,6.2410164 C13.94543,6.427685 14.0609867,6.60546463 14.1578766,6.85435613 C14.2308774,7.04213587 14.3178783,7.32436103 14.3415452,7.84436643 C14.367101,8.4065945 14.3726567,8.57548517 14.3726567,9.99883333 C14.3726567,11.4221815 14.367101,11.5910721 14.3415452,12.1533002 C14.3177672,12.6733056 14.2308774,12.9555308 14.1578766,13.1433105 C14.061209,13.392202 13.94543,13.5694261 13.7587614,13.7559836 C13.5720928,13.9426522 13.3948687,14.0582089 13.1458661,14.1548766 C12.9580864,14.2282107 12.675639,14.3148783 12.1556336,14.3386563 C11.5934055,14.3642121 11.4245148,14.3697677 10.0005,14.3697677 C8.57637407,14.3697677 8.40759453,14.3642121 7.84536643,14.3386563 C7.32536103,14.3146561 7.04313587,14.2277663 6.8550228,14.1547655 C6.6061313,14.0580978 6.4283517,13.9425411 6.24168307,13.7558725 C6.05501447,13.5692038 5.9394577,13.3918687 5.8425678,13.1428661 C5.76956703,12.9550863 5.68256613,12.6728612 5.65889923,12.1528558 C5.6333434,11.5906277 5.62823223,11.421737 5.62823223,9.99749997 C5.62823223,8.5732629 5.6333434,8.40526117 5.65889923,7.8430331 C5.68267727,7.32302767 5.76956703,7.0408025 5.8425678,6.85280057 C5.93923547,6.60390907 6.05501447,6.42612943 6.24168307,6.23946083 C6.4283517,6.0527922 6.6061313,5.93723547 6.8550228,5.84034557 C7.04302477,5.76701147 7.32536103,5.6803439 7.84536643,5.65645477 C8.33737157,5.6342323 8.52804023,5.62756557 9.52205057,5.62645443 L9.52205057,5.6277878 Z M12.8474185,6.51335257 C12.4940815,6.51335257 12.2074119,6.7996889 12.2074119,7.153137 C12.2074119,7.50647403 12.4940815,7.79314367 12.8474185,7.79314367 C13.2007556,7.79314367 13.4874252,7.50647403 13.4874252,7.153137 C13.4874252,6.7998 13.2007556,6.51313033 12.8474185,6.51313033 L12.8474185,6.51335257 Z M10.0005,7.26113813 C8.4879287,7.26113813 7.2615826,8.48748423 7.2615826,10.0000556 C7.2615826,11.5126269 8.4879287,12.7384174 10.0005,12.7384174 C11.5130713,12.7384174 12.738973,11.5126269 12.738973,10.0000556 C12.738973,8.48748423 11.5129602,7.26113813 10.0003889,7.26113813 L10.0005,7.26113813 Z"
														id="Combined-Shape" />
													<path
														d="M10.0005,8.22225927 C10.982288,8.22225927 11.7782963,9.01815643 11.7782963,10.0000556 C11.7782963,10.9818436 10.982288,11.7778519 10.0005,11.7778519 C9.0186009,11.7778519 8.2227037,10.9818436 8.2227037,10.0000556 C8.2227037,9.01815643 9.0186009,8.22225927 10.0005,8.22225927 L10.0005,8.22225927 Z"
														id="Shape" />
												</g>
											</g>
										</g></svg
								></a>
							</li>
							
							<li>
								<a href="https://www.youtube.com/@123FLYco"
									><svg
										width="20px"
										height="20px"
										viewBox="0 0 20 20"
										version="1.1"
										xmlns="http://www.w3.org/2000/svg"
										xmlns:xlink="http://www.w3.org/1999/xlink">
										<g
											id="Symbols"
											stroke="none"
											stroke-width="1"
											fill="none"
											fill-rule="evenodd">
											<g
												id="footer/idle"
												transform="translate(-300.000000, -130.000000)">
												<rect
													fill="#F5F6F6"
													x="0"
													y="0"
													width="1440"
													height="522" />
												<g
													id="Icon/Youtube"
													transform="translate(300.000000, 130.000000)"
													fill="#3A3A3A">
													<path
														d="M0,10 C0,4.47715223 4.47715223,0 10,0 C15.5228478,0 20,4.47715223 20,10 C20,15.5228478 15.5228478,20 10,20 C4.47715223,20 0,15.5228478 0,10 Z M15.1104242,7.53050807 C14.9877576,7.05925537 14.626303,6.68816397 14.1673333,6.56222043 C13.3355758,6.33333333 10,6.33333333 10,6.33333333 C10,6.33333333 6.66442423,6.33333333 5.83260607,6.56222043 C5.37363637,6.68816397 5.01218183,7.05925537 4.88951517,7.53050807 C4.66666667,8.38459947 4.66666667,10.1666667 4.66666667,10.1666667 C4.66666667,10.1666667 4.66666667,11.948672 4.88951517,12.8028253 C5.01218183,13.274078 5.37363637,13.6451694 5.83260607,13.7711747 C6.66442423,14 10,14 10,14 C10,14 13.3355758,14 14.1673333,13.7711747 C14.626303,13.6451694 14.9877576,13.274078 15.1104242,12.8028253 C15.3333333,11.948672 15.3333333,10.1666667 15.3333333,10.1666667 C15.3333333,10.1666667 15.3333333,8.38459947 15.1104242,7.53050807 Z"
														id="Combined-Shape" />
													<polygon
														id="Fill-2"
														points="9 12 9 8.66666667 11.6666667 10.333397" />
												</g>
											</g>
										</g></svg
								></a>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
		<div class="main-footer-nav row">
			<div class="container clear-padding">
				<div class="col-md-6 col-sm-6">
					<p>
						Copyright &copy; {{currentYear}}. All Rights Reserved. Powered by
						<a
							href="https://www.algebratec.com"
							style="font-weight: 500; color: white"
							target="_blank"
							>Algebratec</a
						>
					</p>
				</div>

				<div class="go-up">
					<a (click)="goToTop()"><i class="fa fa-arrow-up"></i></a>
				</div>
			</div>
		</div>
	</footer>
</section>
